
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type NewsResponseMediaLinksItemLinkType = typeof NewsResponseMediaLinksItemLinkType[keyof typeof NewsResponseMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NewsResponseMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
